export class SaveSelectedItemEnabler {
  static handlesSavePath(val) {
    const standardPaths = [
      '%ALLUSERSPROFILE%',
      '%AppData%',
      '%HOMEPATH%',
      '%LOCALAPPDATA%',
      '%ProgramFiles%',
      '%USERPROFILE%',
      '%CommonProgramFiles%',
      '%COMMONPROGRAMFILES(X86)%',
      '%WinDir%',
      '%WINDIR%\\system32',
      '%PROGRAMFILES(X86)%',
      '%TEMP%',
    ];

    for (const i in standardPaths) {
      if (val == standardPaths[i]) {
        return true;
      }
    }

    standardPaths.forEach(item => {
      let splitPath = val.split(item);

      if (splitPath > 1) {
        val = 'x:' + splitPath[1];
      }
    });

    return !!val.match(
      /^((\\\\[a-zA-Z0-9-]+\\[a-zA-Z0-9`~!@#$%^&(){}'._-]+([ ]+[a-zA-Z0-9`~!@#$%^&(){}'._-]+)*)|([a-zA-Z]:))(\\[^ \\/:*?""<>|]+([ ]+[^ \\/:*?""<>|]+)*)*\\?$/
    );
  }
}
